import { render, staticRenderFns } from "./surpriseInfo.vue?vue&type=template&id=ffd381b8&"
import script from "./surpriseInfo.vue?vue&type=script&lang=js&"
export * from "./surpriseInfo.vue?vue&type=script&lang=js&"
import style0 from "./surpriseInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports